import {FormError, FormLabel,getInputClassNames,getInputWrapperClass, getWholeDivWrapperClass} from "./sharedStyles.tsx";
import React from "react";
import {SpacerComponent, FormComponentProps, BaseFormComponent} from "../DynamicFormTypes.ts";


export const SpacerRenderer: React.FC<FormComponentProps<SpacerComponent>> = ({ component }) => {
    if (component.size == 1) {
        return (
            <div className={getWholeDivWrapperClass(component) + " invisible"}>
                <FormLabel component={component}></FormLabel>
                <div className={getInputWrapperClass(component)}>
                    <span className={getInputClassNames(component, undefined)}>
                        {component.size}
                    </span>
                </div>
                <FormError fieldState={undefined} component={component}/>
            </div>
        );
    } else if (component.size == 0) {
        return (
            <div className={getWholeDivWrapperClass(component) + " mt-1 mb-1"}>
                <FormLabel component={{...component, label: " "} as BaseFormComponent}></FormLabel>
            </div>
        );
    } else {
        return (
            <div
                className={`h-${component.size} invisible`}
            ></div>
        );
    }
};

export const Spacer = React.memo(SpacerRenderer);